"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _breakpoints = require("../constants/breakpoints");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: ", ";\n  overflow-x: scroll;\n  overflow-y: hidden;\n  height: auto;\n"])), function (props) {
  return props.desktopWidth;
});

var ScrollableBox = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n\n  @media only screen and (max-width: ", ") {\n    width: ", ";\n  }\n"])), function (props) {
  return props.desktopWidth;
}, _breakpoints.MAX_DESKTOP_BREAKPOINT, function (props) {
  return props.mobileWidth;
});

var Scrollable = function Scrollable(_ref) {
  var children = _ref.children,
      desktopWidth = _ref.desktopWidth,
      mobileWidth = _ref.mobileWidth;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(ScrollableBox, {
    desktopWidth: desktopWidth,
    mobileWidth: mobileWidth
  }, children)));
};

Scrollable.propTypes = {
  children: _propTypes["default"].node.isRequired,
  desktopWidth: _propTypes["default"].string,
  mobileWidth: _propTypes["default"].string
};
Scrollable.defaultProps = {
  desktopWidth: '100%',
  mobileWidth: '1000px'
};
var _default = Scrollable;
exports["default"] = _default;